import { useState } from 'react';
import './App.css';
import Background from './components/background/Background';
import Todo from './components/todo/Todo';
function App() {
  const [theme,setTheme] = useState("dark")
  function handleTheme(){
    let mode = theme==="dark"? "light" :"dark"
    setTheme(mode)
  }
  return (
    <div className="App" >
      <Todo theme={theme} changeTheme={handleTheme} />
      <Background theme={theme}/>
    </div>
  );
}

export default App;
